import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
	HeadingBox,
	Logo,
	Button,
	DialogHandler,
} from "cakemail-ui-components/lib/react";
import { I18n, Translate } from "react-redux-i18n";
import { callAPI, GATEWAY_PROXY, METHODS } from "utils/apiUtils";
import fetchRoute from "utils/routes";
import { getReferalBadgeLink } from "utils/IsValidEmail";
import { LIMIT_FEATURE, limitsFeaturesAccess } from "utils/LimitsAndFeatures";

const ListGlobalUnsubscribeForm = (props) => {
	function handleFormClick(e, btnRef) {
		btnRef.startAnimation();
		if (props.action) {
			callAPI(
				{
					url: GATEWAY_PROXY + "/formAction",
					query: { action: props.action },
					method: METHODS.post,
				},
				() => {
					props.history.push(fetchRoute("listUnsubscribeAll"));
				},
				() => {
					btnRef.reset();
					DialogHandler.show({
						type: "warning",
						title: <Translate value="app-general-error-general" />,
					});
				}
			);
		} else {
			btnRef.reset();
			DialogHandler.show({
				type: "warning",
				title: <Translate value="app-general-error-general" />,
			});
		}
	}

	let title = (
		<Translate
			value="app-lists-initial-redirection-global-unsubscription-form-title"
			name={props.accountName ? props.accountName : ""}
		/>
	);
	let text = I18n.t(
		"app-lists-initial-redirection-global-unsubscription-form-desc"
	);

	let logoLink = getReferalBadgeLink(
		props.campaignId,
		"campaign",
		"global_unsubscribe"
	);
	const removeLogo = limitsFeaturesAccess(
		LIMIT_FEATURE.INSERT_RESELLER_LOGO,
		props.publicUserBrand?.config?.usage_limits
	);

	return (
		<div className="optOut">
			{props.goodImg && (
				<img
					className="accountLogo"
					src={props.imgUrl}
					{...props.imgExtraAttr}
				/>
			)}
			<HeadingBox title={title} text={text} />

			<Button
				colorTheme="grey"
				radius="square"
				size="medium"
				text={I18n.t("app-lists-initial-redirection-unsubscription-button")}
				onClick={handleFormClick}
				animated
			/>

			{!removeLogo && (
				<a href={logoLink}>
					<Logo url={props.logo} alt={props.resellerName} />
				</a>
			)}
		</div>
	);
};

ListGlobalUnsubscribeForm.propTypes = {
	logo: PropTypes.string,
	resellerName: PropTypes.string,
	history: PropTypes.object,
	goodImg: PropTypes.bool,
	imgUrl: PropTypes.string,
	imgExtraAttr: PropTypes.object,
	action: PropTypes.string,
	addUtm: PropTypes.func,
	listName: PropTypes.string,
	formId: PropTypes.string,
	listId: PropTypes.string,
	campaignId: PropTypes.string,
	publicUserBrand: PropTypes.object,
	accountName: PropTypes.string,
};

export default withRouter(ListGlobalUnsubscribeForm);
